import { render } from "./LegalBar.vue?vue&type=template&id=0b243657&scoped=true"
import script from "./LegalBar.vue?vue&type=script&lang=js"
export * from "./LegalBar.vue?vue&type=script&lang=js"

import "./LegalBar.vue?vue&type=style&index=0&id=0b243657&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b243657"]])

export default __exports__